<template>
  <div>
    <van-popup v-model="show" position="right" style="width:100%;height:100%;">
      <div class="bg-white popup-box">
        <section class="container-footer">
          <div class="popup-del flex all-c">
            <span class="icon icon-chacha f18" @click="show=false"></span><span class="flex-1 txt-c f20 pr16">性别</span>
          </div>
          <div class="home-per">
                <div class="ds-partime-list flex space-b">
                  <p class="van-bor1 flex-1 van-hairline--surround" :class="{'selected':userGenderList.indexOf(1)>-1}"
                     @click="onCheck(1,'userGenderList')">
                    <span class="block txt-elips">男性</span>
                  </p>
                  <p class="van-bor1 flex-1 van-hairline--surround" :class="{'selected':userGenderList.indexOf(2)>-1}"
                     @click="onCheck(2,'userGenderList')">
                    <span class="block txt-elips">女性</span>
                  </p>
                </div>
              <!-- </van-collapse-item>
            </van-collapse> -->
          </div>
        </section>
        <footer class="footer-fixed flex all-c">
          <van-button block type="default" class="flex-1 radius-0" @click="clear">
            <span class="f16 c-orange">重置</span>
          </van-button>
          <van-button block type="primary" class="flex-1 btn-gradient radius-0" @click="search">
            <span class="f16">确定</span>
          </van-button>
        </footer>
      </div>
    </van-popup>
  </div>
</template>

<script>

  const { GenderTypes } = require('../../../libs/config');

  export default {
    data() {
      return {
        show: false,
        genderTypes: GenderTypes,
        showFilter: false,
        activeNames: ['0', '1', '2', '3', '4', '5', '6'],
        userGenderList: [],
        userGenderName: ''
      };
    },
    mounted() {
    },
    methods: {
      onCheck(item, key) {
        const index = this[key].indexOf(item);
        if (index > -1) {
          this[key].splice(index, 1);
        } else {
          this[key].push(item);
        }
      },
      clear() {
        this.userGenderList = [];
      },
      search() {
        this.userGenderName = '';
        if (this.userGenderList.length === 2) {
          this.userGenderName = '不限';
        } else if (this.userGenderList.length === 1 && this.userGenderList[0] === 1) {
          this.userGenderName = '男性';
        } else if (this.userGenderList.length === 1 && this.userGenderList[0] === 2) {
          this.userGenderName = '女性';
        } else {
          this.userGenderName = '不限';
        }
        this.$emit('search', {
          UserGenderList: this.userGenderList,
          UserGenderName: this.userGenderName
        });
        this.show = false;
      }
    }
  };
</script>

<style lang="less" scoped>
  @import '../../../assets/css/theme.less';
  .popup-del{ padding: 10px 0 5px 15px;}
  .drawline {
    height: 1px;
    width: 100%;
  }

  .ds-partime-list {
    margin: 30px 20px;
  }
  .ds-partime-list p{
    margin:0;
    height: 35px;
    line-height: 36px;
    font-size: 14px;
  }
  .ds-partime-list p:not(:last-child){
    margin-right: 20px;
  }

  .fringe .van-cell__value--alone {
    color: #666;
  }

  .van-hairline--top-bottom::after {
    border-width: 0;
  }
</style>
